export const TOKEN_KEY = 'token'

export const setToken = (token) => {
    sessionStorage.setItem(TOKEN_KEY, token)
}
  
export const getToken = () => {
    const token = sessionStorage.getItem(TOKEN_KEY)
    if (token) return token
    else return false
}


// WEBPACK FOOTER //
// ./src/libs/util.js